import { DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';
import { defaultMemoize } from 'reselect/lib';

import { IOrderClause } from '@tableau/data-catalog-client-components/lib/src/utils/VizPortalTypes';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { getHeightForRows, SortableDataGrid } from '../../../common/react/components/dataGrid/SortableDataGrid';
import { cssClass, flexColumnStyle } from '../../../style';
import { IPublishedConnectionInfo } from '../../../ts/models/IPublishedConnectionInfo';
import { ISliceable } from '../../../ts/models/ISliceable';
import { SliceableFactory } from '../../../ts/services/SliceableFactory';

const cssPrefix = 'PublishedConnectionTablesGrid';

const rootClass = cssClass(cssPrefix, 'root', flexColumnStyle, {
  position: 'relative',
  minHeight: getHeightForRows(2),
  paddingBottom: CommonStyles.Sizes.LargeSpace,
  borderBottom: '1px solid black',
  width: '100%'
});

function getRowData(sliceableFactory: SliceableFactory): (orderClause: IOrderClause[]) => ISliceable<any> {
  return (_orderClause: IOrderClause[]) => sliceableFactory.fromArray([]);
}

export type PublishedConnectionTablesGridProps = {
  readonly publishedConnectionInfo: IPublishedConnectionInfo;
};

export class PublishedConnectionTablesGrid extends React.PureComponent<PublishedConnectionTablesGridProps> {
  private memoizedGetRowData = defaultMemoize(getRowData);
  private sliceableFactory: SliceableFactory;

  constructor(props: PublishedConnectionTablesGridProps) {
    super(props);
    this.sliceableFactory = ServiceLocator.get<SliceableFactory>('SliceableFactory');
  }

  private emptyChild(): JSX.Element {
    return (
      <div className={'tb-data-grid-empty'}>
        <div className={'tb-data-grid-empty-title'}>{Messages.publishedConnectionTablesEmpty()}</div>
      </div>
    );
  }

  public render(): JSX.Element {
    const numOfRows: number = 0;
    const columns: DataGrid.Column[] = [];
    const sliceable: (orderClause: IOrderClause[]) => ISliceable<any> = this.memoizedGetRowData(this.sliceableFactory);
    const heightStyle: React.CSSProperties = {
      height: numOfRows ? getHeightForRows(numOfRows + 1) : undefined
    };
    return (
      <div className={rootClass} style={heightStyle}>
        <SortableDataGrid
          columns={columns}
          getSliceable={sliceable}
          emptyChild={this.emptyChild()}
        />
      </div>
    );
  }
}
